import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { LocaleLink } from '@common/components';
import { ButtonExpand } from './ButtonExpand';
import { useAnalytics } from '@utils/analytics';
import styles from './ExpandableList.module.scss';
import { getLanguagePrefix } from '@helpers';

export const ExpandableList = ({ expanded, items, title, listRole }) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  const { trackInteraction } = useAnalytics();
  const { prefixLanguage: language } = useSelector(({ appState }) => appState);

  const handleClick = () => {
    setIsExpanded(previous => !previous);
  };

  return (
    <Fragment>
      <ButtonExpand onClick={handleClick} expanded={isExpanded}>
        {title}
      </ButtonExpand>

      {isExpanded && (
        <ul className={styles.list} role={listRole} aria-label={title}>
          {items.map(item => (
            <li className={styles.item} key={item.drupal_id}>
              <LocaleLink
                to={
                  window.location.origin +
                  getLanguagePrefix(language) +
                  item.link.uri.replace('internal:', '')
                }
                className={styles.link}
                onClick={() =>
                  trackInteraction(
                    'side-navigation',
                    item.title,
                    item.link.uri.replace('internal:', ''),
                    'side-navigation'
                  )
                }
              >
                {item.title}
              </LocaleLink>
            </li>
          ))}
        </ul>
      )}
    </Fragment>
  );
};

ExpandableList.propTypes = {
  onClick: PropTypes.func,
  expanded: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.arrayOf(PropTypes.any),
  title: PropTypes.string,
  listRole: PropTypes.string,
};

ExpandableList.defaultProps = {
  onClick: () => {},
  expanded: false,
  items: [],
  title: null,
  listRole: 'menu',
};
